module.exports = "/_next/static/images/2380916bb8d122626e214299e61ab060-locked-deposits@2x.jpg.webp";